export const MEXICO_TIME_ZONE = 'America/Mexico_City';

// Date represents an instant; apply the time zone when formatting, never by shifting it.
export const toMexicoTime = (value) => new Date(value);

export const getMexicoDateKey = (value = new Date()) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    throw new RangeError('Fecha invalida');
  }
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: MEXICO_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(date);
  const part = (type) => parts.find((item) => item.type === type).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
};

export const getTodayInMexico = () => getMexicoDateKey();

export const formatMexicoDateTime = (value) => {
  if (value === null || value === undefined || value === '') return 'N/A';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    console.error('Fecha invalida:', value);
    return 'Fecha invalida';
  }
  return date.toLocaleString('es-MX', {
    timeZone: MEXICO_TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
};

export const formatMexicoDate = (value) => new Date(value).toLocaleDateString('es-MX', {
  timeZone: MEXICO_TIME_ZONE, month: 'short', day: 'numeric'
});

export const mexicoDateJsonReplacer = (key, value) => (
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(value)
    ? `${formatMexicoDateTime(value)} (${MEXICO_TIME_ZONE})` : value
);

export const getMexicoMonthRange = (previous = false, now = new Date()) => {
  const [year, month] = getMexicoDateKey(now).split('-').map(Number);
  const start = new Date(Date.UTC(year, month - 1 - Number(previous), 1));
  const end = new Date(Date.UTC(year, month - Number(previous), 0));
  return {
    startDate: start.toISOString().slice(0, 10),
    endDate: previous ? end.toISOString().slice(0, 10) : getMexicoDateKey(now)
  };
};

export const isToday = (value) => getMexicoDateKey(value) === getTodayInMexico();

export const isYesterday = (value) => {
  const yesterday = new Date(`${getTodayInMexico()}T12:00:00Z`);
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);
  return getMexicoDateKey(value) === yesterday.toISOString().slice(0, 10);
};

export const getRelativeDateText = (value) => (
  isToday(value) ? 'Hoy' : isYesterday(value) ? 'Ayer' : formatMexicoDate(value)
);
